import React from 'react';


export function useTable() {
  const [search, setSearch] = React.useState('');
  const [sortByCol, setSortByCol] = React.useState<number>();
  const [sortDirection, setSortDirection] = React.useState<'asc'|'desc'>();

  function handleSort(i: number) {
    if (sortByCol !== i) {
      setSortByCol(i);
      setSortDirection('asc');
    } else {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    }
  }

  return {
    handleSort,
    search: {
      value: search,
      setValue: setSearch,
    },
    sortByCol,
    sortDirection,
  }
}